module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05_ded"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_c('em', [_vm._v("To Alexander,"), _c('br'), _vm._v("and to Peter and Constantine,"), _c('br'), _vm._v("the three “Greats” in my life!")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerv"
  }, [_vm._v("“The physician must … have two special objects in view"), _c('br'), _vm._v("with regard to disease, namely, to do good or to do no harm.”"), _c('br'), _vm._v("—Hippocrates, "), _c('em', [_vm._v("Epidemics,")]), _vm._v(" fifth century BC"), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e19643c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_ded.vue
// module id = 72
// module chunks = 0